import env from '@maui-mf/env'
import { useTreatment } from '@maui-mf/splitio-react'
import { useAuthProvider } from '@maui-mf/common-react'

export const useIsGTI = () => {
  const { isGTI: user, profile } = useAuthProvider()
  const uxGranted = useTreatment(env.FEATURE_GTI_UX)
  const ux = uxGranted && profile?.preferences?.showClassicUI === false

  return {
    user,
    ux: user || ux,
    uxGranted: user || uxGranted,
  }
}
